import { NavLink } from "react-router-dom";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import useEnv from "../hooks/useEnv";

const messages = defineMessages({
    accountDetails: {
        id: "Tilin tiedot",
        defaultMessage: "Tilin tiedot"
    },
    bankAccountDetails: {
        id: "Pankkitilin tiedot",
        defaultMessage: "Pankkitilin tiedot"
    },
    passkeys: {
        id: "Luotettu kirjautuminen",
        defaultMessage: "Luotettu kirjautuminen"
    }
})

const SettingsMenu = (props) => {
    const { isEnvTruthy } = useEnv();
    const lng = props.intl.formatMessage;

    return (
        <div className={`settings-menu ${props.section === undefined ? 'preselect-first' : ''}`}>
            <NavLink to='/user/settings/accountDetails'>
                {lng(messages.accountDetails)}
            </NavLink>
            <NavLink to='/user/settings/bankaccount'>
                {lng(messages.bankAccountDetails)}
            </NavLink>
            {isEnvTruthy('USE_PASSKEYS') && (
                <NavLink to='/user/settings/passkeys'>
                    {lng(messages.passkeys)}
                </NavLink>
            )}
        </div>
    )
}

SettingsMenu.propTypes = {
    'intl': PropTypes.object.isRequired,
    'section': PropTypes.string
};

export default injectIntl(SettingsMenu);
